import "./../../../api";

import { HOME_PATH } from "../../../constants/RoutesConstants";
//import { HOME_PATH } from "../../../constants/RoutesConstants";
//import { LOGIN_MODAL } from "../../../constants/ModalConstants";
import { Normalize } from "styled-normalize";
import React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router";

//import React, { useCallback, useEffect } from "react";
//import { useDispatch, useSelector } from "react-redux";
//import { useHistory, useLocation } from "react-router";

//import getIdSelector from "../../../state/selectors/ClientSelectors/getIdSelector";
//import setActiveModalAction from "../../../state/actions/ModalActions/setActiveModalAction";

const Setup: React.FC = () => {
    const { replace } = useHistory();
    const userAgent = navigator.userAgent.toLowerCase();
    /*const isUserLoggedIn = useSelector((state: Store) => getIdSelector(state));
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const openModal = useCallback(() => dispatch(setActiveModalAction(LOGIN_MODAL)), [dispatch]);
    useEffect(() => {
        if (!isUserLoggedIn) {
            history.replace(HOME_PATH);
            openModal();
        }
    }, [isUserLoggedIn, location.pathname, history, openModal]);*/
    useEffect(() => {
        if (userAgent.indexOf(" electron/") > -1) {
            replace(HOME_PATH);
        }
    }, [replace, userAgent]);
    return <Normalize />;
};

export default Setup;
